var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgCamera = function SvgCamera(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 34 34"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "inherit",
    fillRule: "evenodd",
    d: "M9.35 14.875a2.525 2.525 0 0 1 2.525-2.525h6.563a2.525 2.525 0 0 1 2.524 2.525v.562l2.814-1.915.057-.035c.308-.166.763-.31 1.197-.085.448.233.58.704.602 1.072l.002.038.016 5.448c.007.441-.183.889-.633 1.093-.412.187-.85.08-1.17-.118l-.038-.025-2.847-2.039v.691a2.525 2.525 0 0 1-2.524 2.525h-6.563a2.525 2.525 0 0 1-2.525-2.525zm10.313 2.722v1.966c0 .676-.549 1.224-1.226 1.224h-6.562a1.225 1.225 0 0 1-1.225-1.225v-4.687c0-.677.548-1.225 1.225-1.225h6.563c.676 0 1.225.548 1.225 1.225v2.722m1.3-.325 3.386 2.426-.015-4.984-3.372 2.295z",
    clipRule: "evenodd"
  })));
};
export default SvgCamera;